module.exports = __webpack_public_path__ + "media/60.0f53ee3f.mp3";